export default "__VITE_ASSET__DVy9RBiQ__"